module.exports = __webpack_public_path__ + "img/company.c4cf4156.jpg";